<table class="breakdown">
  <thead>
    <tr>
      <th>{{ 'CashRequest_Concept' | translateWF: 'Concept' }}</th>
      <th class="text-right">{{ 'CashRequest_Amount' | translateWF: 'Amount' }}</th>
    </tr>
  </thead>
  <tbody>
    @for (row of rows(); track row.concept) {
      <tr>
        <td>{{ (row.name | localized) || row.concept }}</td>
        <td class="text-right tabular-nums">{{ row.amount | number: '1.2-2' }} {{ currencyLabel }}</td>
      </tr>
    } @empty {
      <tr>
        <td colspan="2" class="empty">{{ 'CashRequest_NoLines' | translateWF: 'No lines' }}</td>
      </tr>
    }
  </tbody>
  <tfoot>
    <tr>
      <td>{{ totalLabel || ('Total' | translateWF: 'Total') }}</td>
      <td class="text-right tabular-nums">{{ total() | number: '1.2-2' }} {{ currencyLabel }}</td>
    </tr>
  </tfoot>
</table>
